import { render } from "./BoardSalaryReview.vue?vue&type=template&id=1dbc8706&scoped=true"
import script from "./BoardSalaryReview.vue?vue&type=script&lang=js"
export * from "./BoardSalaryReview.vue?vue&type=script&lang=js"

import "./BoardSalaryReview.vue?vue&type=style&index=0&id=1dbc8706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbc8706"]])

export default __exports__